'use client';

import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { ReactNode } from 'react';

import { Button } from '@/vibes/mom/primitives/button';

interface BenefitsSliderProps {
  children: ReactNode;
  options?: EmblaOptionsType;
}

const BenefitsSlider = ({ children, options }: BenefitsSliderProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    axis: 'x',
    loop: false,
    align: 'start',
    slidesToScroll: 1,
    ...options,
  });

  const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
  const scrollNext = () => emblaApi && emblaApi.scrollNext();

  return (
    <div className="flex gap-2">
      <div className="w-full min-w-0 overflow-hidden" ref={emblaRef}>
        <div className="flex w-full items-center">{children}</div>
      </div>

      <div className="flex items-center justify-end lg:hidden">
        <Button className="flex !h-10 w-10 items-center" onClick={scrollPrev} variant="ghost">
          <ChevronLeft />
        </Button>
        <Button className="flex !h-10 w-10 items-center" onClick={scrollNext} variant="ghost">
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export default BenefitsSlider;
